import BaseWidget from 'components/BaseWidget/BaseWidget';
import DeviceSettingsModals from 'features/Integrations/features/ConnectedDevices/features/DeviceList/DeviceModals/DeviceSettingsModals/DeviceSettingsModals';
import { selectIntegrationFetching } from 'features/Integrations/state/selectors/integrationSelectors';
import { useSelector } from 'react-redux';
import BuoyGraphWidget from './widgets/BuoyGraphWidget/BuoyGraphWidget';
import BuoyMapWidget from './widgets/BuoyMapWidget/BuoyMapWidget';
import DeviceGraphWidget from './widgets/DeviceGraphWidget/DeviceGraphWidget';
import DeviceListWidget from './widgets/DeviceListWidget/DeviceListWidget';
import DeviceMapWidget from './widgets/DeviceMapWidget/DeviceMapWidget';
import FloodMapWidget from './widgets/FloodMapWidget/FloodMapWidget';
import RescAlertDevicesWidget from './widgets/RescAlertDevicesWidget/RescAlertDevicesWidget';

const ConnectedDevicesWidget = ({
  widgetType,
  dimensions,
  widget,
  setShowCurrentDevice,
  setShowDeviceSettings,
  selectedGroup,
  setSelectedGroup,
  nested,
  deviceForWidget,
}) => {
  const fetching = useSelector(selectIntegrationFetching);
  const renderDeviceControls = ({ widgetType, dimensions }) => (
    <RescAlertDevicesWidget
      type={widgetType}
      dimensions={dimensions}
      nested={nested}
      deviceForWidget={deviceForWidget}
    />
  );
  const deviceControlRenderers = {
    technologyBridgeFlashingLights: renderDeviceControls,
    manualRoadClosure: renderDeviceControls,
    technologyBridgeSiren: renderDeviceControls,
  };
  const hasDeviceControls = Object.hasOwn(deviceControlRenderers, widgetType);

  return (
    <>
      <BaseWidget
        widgetType={widgetType}
        dimensions={dimensions}
        isLoading={fetching}
        renderers={{
          list: () => (
            <DeviceListWidget
              setShowCurrentDevice={setShowCurrentDevice}
              setShowDeviceSettings={setShowDeviceSettings}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
            />
          ),
          graph: () => (
            <DeviceGraphWidget
              setShowCurrentDevice={setShowCurrentDevice}
              selectedGroup={selectedGroup}
              widget={widget}
            />
          ),
          map: ({ dimensions }) => (
            <DeviceMapWidget
              setShowCurrentDevice={setShowCurrentDevice}
              setShowDeviceSettings={setShowDeviceSettings}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
              filtersCompact={dimensions?.[0] === 1 && dimensions?.[1] === 1}
            />
          ),
          buoyMap: () => <BuoyMapWidget />,
          buoyGraph: () => <BuoyGraphWidget />,
          stageFloodMap: () => <FloodMapWidget />,
          ...deviceControlRenderers,
        }}
        route={widgetType === 'list' || hasDeviceControls ? null : 'getNodes'}
      />
      {!hasDeviceControls && <DeviceSettingsModals />}
    </>
  );
};

export default ConnectedDevicesWidget;
